import { FaUsers } from "react-icons/fa"
import { PiStudent, PiWarningCircle } from "react-icons/pi"
import { LiaMoneyBillWaveAltSolid } from "react-icons/lia";
import { HiMiniArrowTrendingUp } from "react-icons/hi2";

interface Props {
    title: string,
    icon: string,
    description: string,
    subtitle?: string,
    compared?: boolean,
    comparedMoney?: boolean
}


export const Cards = ({ title, icon, description, subtitle, compared = false, comparedMoney = false }: Props) => {

    const icons: Record<string, JSX.Element> = {
        "childrens": <FaUsers size={20} />,
        "student": <PiStudent size={20} />,
        "warning": <PiWarningCircle size={20} />,
        "money": <LiaMoneyBillWaveAltSolid size={20} />
    }




    return (
        <div className="bg-white dark:bg-blue-cole-dark-surface rounded-lg p-4 lg:p-5 shadow-md border border-transparent dark:border-gray-dark/40">
            <div className="flex justify-between">
                <h2 className="font-semibold dark:text-white">{title}</h2>
                <p className="text-sm text-blue-cole dark:text-ink-muted-dark">{icons[icon]}</p>
            </div>
            <div className="mt-4 lg:mt-5">
                <div className="flex items-center gap-3">
                    <p className="font-bold text-xl lg:text-2xl dark:text-white">{description}</p>
                    {
                        compared && <div className="border rounded-full px-2 py-1 flex items-center gap-2">
                            <HiMiniArrowTrendingUp size={10} />
                            <p className="text-xs"> 0.2</p>

                        </div>
                    }

                    {
                        comparedMoney && <div className="border border-green-400 text-green-400 rounded-full px-2 py-1 flex items-center gap-2">
                            <p className="text-xs">Al dia</p>

                        </div>
                    }



                </div>
                <p className="text-sm text-gray-400">{subtitle}</p>
            </div>
        </div>
    )
}
